import { render, staticRenderFns } from "./HistorialStocks.vue?vue&type=template&id=1dc64f82&"
import script from "./HistorialStocks.vue?vue&type=script&lang=js&"
export * from "./HistorialStocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports